import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "@/Layouts/Layout";
import { NoMatch } from "./Error/NoMatch";
import { Home } from "./home";
import { Evaluate } from "./evaluate";
import CameraPage from "./evaluate/CameraPage";
import { History } from "./history";
import { AboutUs } from "./about-us";
import { Community } from "./community";
// import { Pricing } from "./pricing";
import { EvaluationDetail } from "./evaluation-detail";
import { NotFound } from "./not-found";
import { LoginSignup } from "./login-signup";
import { Profile } from "./profile";
import { Results } from "./results";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import Privacy from "./privacy-policy/Privacy";
import Terms from "./privacy-policy/Terms";
import Security from "./privacy-policy/Security";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
    errorElement: <NoMatch />,
  },
  {
    path: "/evaluate",
    element: (
      <Layout>
        <ProtectedRoute>
          <Evaluate />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/evaluate/camera",
    element: (
      <ProtectedRoute>
        <CameraPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/history",
    element: (
      <Layout>
        <ProtectedRoute>
          <History />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/about-us",
    element: (
      <Layout>
        <AboutUs />
      </Layout>
    ),
  },
  {
    path: "/community",
    element: (
      <Layout>
        <Community />
      </Layout>
    ),
  },
  // {
  //   path: "/pricing",
  //   element: (
  //     <Layout>
  //       <Pricing />
  //     </Layout>
  //   ),
  // },
  {
    path: "/evaluation/:id",
    element: (
      <Layout>
        <ProtectedRoute>
          <EvaluationDetail />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/results",
    element: (
      <Layout>
        <ProtectedRoute>
          <Results />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/login",
    element: (
      <Layout>
        <PublicRoute>
          <LoginSignup />
        </PublicRoute>
      </Layout>
    ),
  },
  {
    path: "/profile",
    element: (
      <Layout>
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/privacy",
    element: (
      <Layout>
        <Privacy />
      </Layout>
    ),
  },
  {
    path: "/terms",
    element: (
      <Layout>
        <Terms />
      </Layout>
    ),
  },
  {
    path: "/security",
    element: (
      <Layout>
        <Security />
      </Layout>
    )
  },
  {
    path: "/404",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
  {
    path: "*",
    element: <NoMatch />,
  },
]);

const Routers: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default Routers;

